import { useEffect, useState } from 'react';
import * as topojson from 'topojson-client';

export const usePreloadCountries = () => {
  const [countries, setCountries] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check cache first
    const cached = localStorage.getItem('cachedCountries');
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        setCountries(parsed);
        setLoading(false);
        return;
      } catch (err) {
        console.warn('Invalid cached countries:', err);
      }
    }

    // Fetch if no cache
    fetch('https://unpkg.com/world-atlas@2.0.2/countries-110m.json')
      .then(res => res.json())
      .then(topology => {
        const loadedCountries = topojson.feature(topology, topology.objects.countries).features;
        setCountries(loadedCountries);
        localStorage.setItem('cachedCountries', JSON.stringify(loadedCountries)); // Cache for next time
        setLoading(false);
      })
      .catch(err => {
        console.error('Preload failed:', err);
        setLoading(false);
      });
  }, []);

  return { countries, loading };
};